export const GET_RECATALOGUES_SUCCESS   = "GET_RECATALOGUES_SUCCESS";
export const GET_CUSTOMERS_SUCCESS      = "GET_CUSTOMERS_SUCCESS";
export const GET_RECATALOGUE_SUCCESS    = "GET_RECATALOGUE_SUCCESS";
export const GET_LISTS_SUCCESS          = "GET_LISTS_SUCCESS";
export const GET_LINES_SUCCESS          = "GET_LINES_SUCCESS";
export const DELETE_RECATALOGUE_SUCCESS = "DELETE_RECATALOGUE_SUCCESS";
export const GET_REQUEST_ERROR          = "GET_REQUEST_ERROR";
export const GET_REQUEST_SUCCESS        = "GET_REQUEST_SUCCESS";